<template>
  <article>
    <section class="xbed-sub-title">
      <span>安卓渠道管理</span>
    </section>

    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>首页</BreadcrumbItem>
        <BreadcrumbItem>安卓渠道管理</BreadcrumbItem>
        <BreadcrumbItem>渠道分析</BreadcrumbItem>
      </Breadcrumb>
    </section>

    <!-- 搜索选择 -->
    <Form :model="channelList" class="channel" inline>
      <FormItem label="渠道" :label-width="50" prop="channel" >
        <Select v-model="channelList.id" class="formWidth" >
          <Option value="S00">全选</Option>
          <Option value="yingyongbao">应用宝</Option>
          <Option value="oppo">oppo</Option>
          <Option value="vivo">vivo</Option>
          <Option value="xbed">xbed</Option>
          <Option value="weixin">微信</Option>
          <Option value="zhihu">知乎</Option>
          <Option value="huawei">华为</Option>
        </Select>
      </FormItem>

      <FormItem label="日期" :label-width="100" prop="channelListDate">
        <DatePicker v-model="channelList.date" :clearable="false" type="daterange" placement="bottom-end" placeholder="选择日期" class="date-time" ></DatePicker>
      </FormItem>

    <!-- 查看按钮 -->
      <FormItem :label-width="50" prop="viewBtn">
        <Button v-model="channelList.viewBtn" type="primary" class="view-btn" @click="viewBtn">查看</Button>
      </FormItem>
    </Form>
    <!-- 表格信息 -->
    <Table border :columns="columnsInfo" :loading="channelList.loading" :data="channelList.data"></Table>
    <Page :total="channelList.count" :page-size="channelList.pageSize" show-sizer @on-change="changePage" @on-page-size-change="changePageSize" class="pages"></Page>
  </article>
</template>

<script>
  import Moment from "moment"
  import Utils from "@/utils";
  import API from "../../api";

  export default{
    created() {
      this.token = Utils.findFromLocalStorage("vue-token");
      this.env = Utils.findFromLocalStorage("env", "dev");
    },

    async mounted() {
     this.analysisChannel();
    },
    
  data(){
    return{
      channelList:{
          page: 1,
          pageSize: 10,
          count: 0,
          data: [],
          loading: false,
          id:'S00',
          date: [Moment().subtract(1, 'day').format('YYYY-MM-DD'), Moment().format('YYYY-MM-DD')],
          viewBtn:''
      },
      // 表格信息
      columnsInfo: [
        {
            title: '日期',
            key: 'createDate',
            align: "center",
            width: 100
        },
        {
            title: '渠道',
            key: 'channelId',
            align: "center",
            width: 100
        },
        {
            title: '今日激活数',
            key: 'dayActive',
            align: "center",
            width: 120
        },
         {
            title: '今日访问用户',
            key: 'dayCall',
            align: "center",
            width: 130
        },
        {
            title: '累计注册用户',
            key: 'accRegister',
            align: "center",
            width: 130
        },
        {
            title: '今日验证用户数',
            key: 'dayValid',
            align: "center",
            width: 140
        },
        {
            title: '累计验证用户数',
            key: 'accValid',
            align: "center",
            width: 140
        },
        {
            title: '今日消费用户数',
            key: 'dayConsumer',
            align: "center",
            width: 140
        },
        {
            title: '今日首次消费用户数',
            key: 'dayFirstConsumer',
            align: "center",
            width: 180
        },
        {
            title: '今日订单量',
            key: 'dayOrders',
            align: "center",
            width: 120
        },
        {
            title: '今日有效订单',
            key: 'dayOrdersValid',
            align: "center",
            width: 130
        },
        {
            title: '今日订房晚数',
            key: 'dayOrderRoom',
            align: "center",
            width: 160
        },
        {
            title: '今日订单金额',
            key: 'dayOrderAmount',
            align: "center",
            width: 140
        },
      ]
      // managementInfo: [
      //   {
      //     creatDate: '',
      //     dayActive: '',
      //     dayCall:'',
      //     accRegister: '',
      //     dayValid:'',
      //     accValid:'',
      //     dayConsumer: '',
      //     dayFirstConsumer:'',
      //     dayOrders:'',
      //     dayOrderValid:'',
      //     dayOrderRoom:'',
      //     channelld:'',
      //   }
      // ]
    }
  },
  methods:{
    changePage(page) {
        this.channelList.page = page;
        this.analysisChannel();
      },
      changePageSize(pageSize) {
        this.channelList.pageSize = pageSize;
        this.analysisChannel();
      },

    viewBtn(){
      this.analysisChannel();
    },
    // 获取搜索数据
    async analysisChannel() {
        console.info(getAnalysisChannel)  
        let params = {
          channelId: this.channelList.id !== 'S00' ? this.channelList.id : '' ,
          beginDate: Moment(this.channelList.date[0]).format('YYYY-MM-DD'),
          endDate: Moment(this.channelList.date[1]).format('YYYY-MM-DD'),
          page: this.channelList.page,
          pageSize: this.channelList.pageSize,
        }
        this.channelList.id !== 'S00' && (params.channelId = this.channelList.id)
        const getAnalysisChannel = (await API.omsAPI[ this.env ].analysis.getAnalysisChannelList(
         params, 
         this.token)).data;
        if (getAnalysisChannel.retCode) {
        this.$Notice.error({
          title: "获取渠道信息失败",
          desc: getAnalysisChannel.msg
        });
        return
      }
        console.info(getAnalysisChannel)
        this.channelList.data = getAnalysisChannel.result;
        this.channelList.count = getAnalysisChannel.pageCount;
      },
    }
  }
</script>

<style lang="scss" scoped>
  .channel {
    margin-top: 20px;
  }

  .formWidth {
    width:200px;
  }
  .view-btn{
    width:80px;
  }
  .date-time{
    width:200px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/android-channel/channel-analysis.vue